import { render, staticRenderFns } from "./constractorsInfo.vue?vue&type=template&id=a85b2404&"
import script from "./constractorsInfo.vue?vue&type=script&lang=js&"
export * from "./constractorsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports